import { render } from "./CalculatorTable.vue?vue&type=template&id=672dff9a"
import script from "./CalculatorTable.vue?vue&type=script&lang=js"
export * from "./CalculatorTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__